<template>
    <CCard >      
      <CCardBody>       
        <CRow>      
          <CCol sm="12" lg="12" >  
            <div class="content-wrapper">                            
              <div id="app">   
                <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                  <ejs-grid ref='grid' locale='zh-TW' :dataSource='this.datas' height='500' :allowExcelExport='true'  :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true'
                    :queryCellInfo='onQueryCellInfo' :toolbar='toolbar' :pageSettings='pageSettings' :beforeRender="beforeRender" :filterSettings='filterSettings' :selectionSettings='selectionSettings' :rowSelected='rowSelected' 
                    :toolbarClick="toolbarClick"  >                             
                    <e-columns> 
                        <e-column field='is_quality' headerText='已檢驗' width='120'></e-column>                    
                        <e-column field='name' headerText='廠商名稱' width='180'></e-column>                      
                        <e-column field='sku_no' headerText='料號'  width='120'></e-column>              
                        <e-column field='sku_name' headerText='料名' width='250'></e-column>   
                        <e-column field='unit' headerText='單位' width='120'></e-column>   
                        <e-column field='sort' headerText='排序' width='120'></e-column>   
                        <e-column field='gdate' headerText='收料日期' width='140'></e-column>  
                        <e-column field='gcount' headerText='收料數量' width='140'></e-column>  
                        <e-column field='ua' headerText='採購單號' width='140'></e-column>     
                        <e-column field='receiptno' headerText='驗收單號' width='140'></e-column>                        
                        <e-column field='save_location' headerText='存放區數量' width='140' ></e-column>   
                        <e-column field='view_qty' headerText='存放區檢視數量' width='160'></e-column>   
                        <e-column field='quality_qty' headerText='品保抽檢數量' width='160'></e-column>
                        <e-column field='product_manager' headerText='生產組組長' width='150'></e-column> 
                        <e-column field='quality_manager' headerText='品保組組長' width='150'></e-column> 
                        <e-column field='write_user' headerText='填表人' width='140'></e-column>                     
                    </e-columns>
                  </ejs-grid>        
                </ejs-tooltip>
              </div>                  
            </div>                
          </CCol>
        </CRow>      

       <div class="control-section">
          <ejs-dialog ref="modalReceiveDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' 
                :header='"品保檢驗單"' :buttons='dialogFractionButtons' width='1000px'>          
              <div formGroup="orderForm"> 
                                      
                <div class="form-row">  
                    <div class="form-group col-md-12">
                     <div class="alert alert-primary" role="alert">
                        建立品保檢驗項目資料，檢查定義檢驗標準。
                     </div>
                    </div>   
                    <div class="form-group col-md-4">
                        <span class="about-title-verify">料號</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_sku_no" :enabled="false"></ejs-textbox>                              
                    </div>                    
                    <div class="form-group col-md-4">
                        <span class="about-title-verify">品名</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_sku_name" :enabled="false"></ejs-textbox>                              
                    </div>
                    <div class="form-group col-md-2">
                        <span class="about-title-verify">進貨日期</span>
                        <ejs-datepicker id="datepicker" format="yyyy-MM-dd" v-model="e_input_date2" :enabled="false"></ejs-datepicker>                      
                    </div>
                      <div class="form-group col-md-2">
                        <span class="about-title-verify">檢驗日期</span>
                        <ejs-datepicker id="datepicker" format="yyyy-MM-dd" v-model="e_input_date" :enabled="false"></ejs-datepicker>                      
                    </div>
                    <div class="form-group col-md-6">
                        <span class="about-title-verify">廠商</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_name" :enabled="false"></ejs-textbox>                      
                    </div>
                    <div class="form-group col-md-6">
                        <span class="about-title-verify">驗收單號</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_receiptno" :enabled="false"></ejs-textbox>                  
                    </div>
                    <div class="form-group col-md-4">
                        <span class="about-title-verify">收料數量</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_save_location" :enabled="false"></ejs-textbox>                              
                    </div>
                    <div class="form-group col-md-4">
                        <span class="about-title-verify">存放區檢視數量</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_view_qty" :enabled="false"></ejs-textbox>                              
                    </div>
                    <div class="form-group col-md-4">
                        <span class="about-title-verify">品保抽驗數量</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_quality_qty" :enabled="false"></ejs-textbox>                      
                    </div>
                    <div class="form-group col-md-12">
                      <div class="form-row">
                        <div class="col-md-2 box-header" style="border-top-width:1px; border-left-width:1px; ">
                            檢驗項目
                        </div>
                        <div class="col-md-3 box-header" style="border-top-width:1px; ">
                            檢驗標準
                        </div>
                        <div class="col-md-5 box-header" style="border-top-width:1px; ">
                            檢驗結果
                        </div>                      
                        <div class="col-md-2 box-header" style="border-top-width:1px; ">
                            備註  
                        </div>
                      </div>                
                 
                      <div v-for="(item, index) in this.quityListData" :key="index" style="pointer-events: none; user-select: none;">
                        <div class="form-row">
                          <div class="col-md-2 box" style="border-left-width:1px; ">
                             <div class="form-group col-md-12">   <!--大於-->            
                                <div class="form-row">
                                  {{ item.item }}                                    
                                </div>                       
                            </div>  
                          </div>
                          <div class="col-md-3 box">
                            <div v-show="item.standard == 1" class="form-group col-md-12">   <!--大於-->            
                                <div class="form-row">
                                  ＞ {{ item.value1 }}                                    
                                </div>                       
                            </div>  
                            <div v-show="item.standard == 2" class="form-group col-md-12">   <!--大於等於-->            
                                <div class="form-row">
                                  ≧ {{ item.value1 }}                                    
                                </div>                       
                            </div> 
                            <div v-show="item.standard == 3" class="form-group col-md-12">   <!--小於-->            
                                <div class="form-row">
                                  ＜ {{ item.value1 }}                                    
                                </div>                       
                            </div>   
                            <div v-show="item.standard == 4" class="form-group col-md-12">   <!--小於等於-->            
                                <div class="form-row">
                                  ≦ {{ item.value1 }}                                    
                                </div>                       
                            </div>  
                             <div v-show="item.standard == 4" class="form-group col-md-12">   <!--數值區間-->            
                                <div class="form-row">
                                  {{ item.value1 }} ~ {{ item.value2 }}
                                </div>                       
                            </div>  
                            <div v-show="item.standard == 11" class="form-group col-md-12">  <!--尺寸(長*寬*高)-->                              
                                <div class="form-row">
                                  長{{ item.value1 }} * 寬{{ item.value2 }} * 高{{ item.value3 }} ± {{ item.value4 }}                                 
                                </div>
                            </div>    
                            <div v-show="item.standard == 12" class="form-group col-md-12">  <!--格數-->                              
                                <div class="form-row">
                                   {{ item.value1 }} ml * {{ item.value2 }}                              
                                </div>
                            </div>  
                            <div v-show="item.standard == 13" class="form-group col-md-12">  <!--厚度-->                              
                                <div class="form-row">
                                   {{ item.value1 }} ± {{ item.value2 }}                              
                                </div>
                            </div>  
                            <div v-show="item.standard == 14" class="form-group col-md-12">  <!--尺寸(長*寬*高)-->                              
                                <div class="form-row">
                                  長{{ item.value1 }} * 寬{{ item.value2 }} ± {{ item.value3 }}                                 
                                </div>
                            </div>    
                            <div v-show="item.standard == 21" class="form-group col-md-12">  <!--正常/不正常-->                              
                                <div class="form-row">
                                   正常                             
                                </div>
                            </div>  
                            <div v-show="item.standard == 22" class="form-group col-md-12">  <!--完整/不完整-->                              
                                <div class="form-row">
                                   完整                             
                                </div>
                            </div>                            
                            <div v-show="item.standard == 23" class="form-group col-md-12">  <!--無/有-->                              
                                <div class="form-row">
                                   無                             
                                </div>
                            </div>  
                            <div v-show="item.standard == 24" class="form-group col-md-12">  <!--平整/不平整-->                              
                                <div class="form-row">
                                   平整                             
                                </div>
                            </div>  
                            <div v-show="item.standard == 25" class="form-group col-md-12">  <!--左出/右出-->                              
                                <div class="form-row">
                                   左出                             
                                </div>
                            </div>  
                            <div v-show="item.standard == 99" class="form-group col-md-12">  <!--不檢查-->                              
                                <div class="form-row">
                                   --                             
                                </div>
                            </div>
                          </div>
                          <div class="col-md-5 box">

                            <div v-show="item.standard == 1" class="form-group col-md-12" style="margin-bottom: 0px;">   <!--大於-->            
                                <div class="form-row">
                                  <div class="form-group col-md-8"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value1" :min="0"></ejs-numerictextbox></div>                                     
                                </div>                       
                            </div>  
                            <div v-show="item.standard == 2" class="form-group col-md-12" style="margin-bottom: 0px;">   <!--大於等於-->            
                                <div class="form-row">
                                  <div class="form-group col-md-8"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value1" :min="0"></ejs-numerictextbox></div>                                 
                                </div>                       
                            </div> 
                            <div v-show="item.standard == 3" class="form-group col-md-12" style="margin-bottom: 0px;">   <!--小於-->            
                                <div class="form-row">
                                  <div class="form-group col-md-8"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value1" :min="0"></ejs-numerictextbox></div>                                     
                                </div>                       
                            </div>   
                            <div v-show="item.standard == 4" class="form-group col-md-12" style="margin-bottom: 0px;">   <!--小於等於-->            
                                <div class="form-row">
                                  <div class="form-group col-md-8"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value1" :min="0"></ejs-numerictextbox></div>                                     
                                </div>                       
                            </div>  
                             <div v-show="item.standard == 4" class="form-group col-md-12" style="margin-bottom: 0px;">   <!--數值區間-->            
                                <div class="form-row">
                                  <div class="form-group col-md-6"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value1" :min="0"></ejs-numerictextbox></div> 
                                  <div class="form-group col-md-6"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value1" :min="0"></ejs-numerictextbox></div>  
                                </div>                       
                            </div>  
                            <div v-show="item.standard == 11" class="form-group col-md-12" style="margin-bottom: 0px;">  <!--尺寸(長*寬*高)-->               
                                <div class="form-row">
                                  <div class="form-group col-md-3"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value1" placeholder="長" :min="0"></ejs-numerictextbox></div>  
                                  <div class="form-group col-md-3"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value2" placeholder="寬" :min="0"></ejs-numerictextbox></div>  
                                  <div class="form-group col-md-3"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value3" placeholder="高" :min="0"></ejs-numerictextbox></div>  
                                  <div class="form-group col-md-3"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value4" placeholder="±" :min="0"></ejs-numerictextbox></div>  
                                </div>  
                            </div>    
                            <div v-show="item.standard == 12" class="form-group col-md-12" style="margin-bottom: 0px;">  <!--格數-->                              
                                <div class="form-row">
                                  <div class="form-group col-md-6"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value1" placeholder="ml" :min="0"></ejs-numerictextbox></div> 
                                  <div class="form-group col-md-6"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value2" :min="0"></ejs-numerictextbox></div>                              
                                </div>
                            </div>  
                            <div v-show="item.standard == 13" class="form-group col-md-12" style="margin-bottom: 0px;">  <!--厚度-->                              
                                <div class="form-row">                            
                                    <div class="form-group col-md-6"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value1" placeholder="mm" :min="0"></ejs-numerictextbox></div> 
                                    <div class="form-group col-md-6"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value2" placeholder="±" :min="0"></ejs-numerictextbox></div>                                            
                                </div>
                            </div>  
                            <div v-show="item.standard == 14" class="form-group col-md-12" style="margin-bottom: 0px;">  <!--尺寸(長*寬)-->               
                                <div class="form-row">
                                  <div class="form-group col-md-4"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value1" placeholder="長" :min="0"></ejs-numerictextbox></div>  
                                  <div class="form-group col-md-4"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value2" placeholder="寬" :min="0"></ejs-numerictextbox></div>  
                                  <div class="form-group col-md-4"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value3" placeholder="±" :min="0"></ejs-numerictextbox></div>  
                                </div>  
                            </div>   
                            <div v-show="item.standard == 21" class="form-group col-md-12" style="margin-bottom: 0px;">  <!--正常/不正常-->                              
                                <div class="form-row">
                                  <div class="form-group col-md-12"><ejs-dropdownlist :dataSource='sType21' allowObjectBinding='true' v-model="item.real_value1" :fields='dropDownFields'></ejs-dropdownlist></div>
                                </div>
                            </div>  
                            <div v-show="item.standard == 22" class="form-group col-md-12" style="margin-bottom: 0px;">  <!--完整/不完整-->                              
                                <div class="form-row">
                                   <div class="form-group col-md-12"><ejs-dropdownlist :dataSource='sType22' allowObjectBinding='true' v-model="item.real_value1" :fields='dropDownFields'></ejs-dropdownlist></div>
                                </div>
                            </div>                          
                            <div v-show="item.standard == 23" class="form-group col-md-12" style="margin-bottom: 0px;">  <!--無/有-->                              
                                <div class="form-row">
                                   <div class="form-group col-md-12"><ejs-dropdownlist :dataSource='sType23' allowObjectBinding='true' v-model="item.real_value1" :fields='dropDownFields'></ejs-dropdownlist></div>                                                 
                                </div>
                            </div>  
                            <div v-show="item.standard == 24" class="form-group col-md-12" style="margin-bottom: 0px;">  <!--平整/不平整-->                              
                                <div class="form-row">
                                   <div class="form-group col-md-12"><ejs-dropdownlist :dataSource='sType24' allowObjectBinding='true' v-model="item.real_value1" :fields='dropDownFields'></ejs-dropdownlist></div>                                                    
                                </div>
                            </div>  
                            <div v-show="item.standard == 25" class="form-group col-md-12" style="margin-bottom: 0px;">  <!--左出/右出-->                              
                                <div class="form-row">
                                   <div class="form-group col-md-12"><ejs-dropdownlist :dataSource='sType25' allowObjectBinding='true' v-model="item.real_value1" :fields='dropDownFields'></ejs-dropdownlist></div>                                                    
                                </div>
                            </div>  
                            <div v-show="item.standard == 99" class="form-group col-md-12" style="margin-bottom: 0px;">  <!--不檢查-->                              
                                <div class="form-row">
                                   --                             
                                </div>
                            </div>  
                          </div>
                          <div class="col-md-2 box">
                            <div class="form-row">
                              <div class="form-group col-md-12"><ejs-textbox floatLabelType="Always"  v-model="item.remark"></ejs-textbox></div>                         
                            </div>
                          </div>                         
                        </div>
                      </div>
                      <div class="form-row" style="padding-top: 12px;">
                        <div class="form-group col-md-6">
                            <span class="about-title">品保組組長</span>
                            <ejs-textbox floatLabelType="Always" v-model="e_quality_manager" :enabled="false"></ejs-textbox>                              
                        </div>

                        <div class="form-group col-md-6">
                            <span class="about-title">填表人</span>
                            <ejs-textbox floatLabelType="Always" v-model="e_write_user" :enabled="false"></ejs-textbox>                              
                        </div>
                       </div>  
                    </div>                      
                </div>
            </div>                 
          </ejs-dialog> 
        </div>

        <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>    
      </CCardBody>   
    </CCard>
  </template>
  <style lang="scss" src="../../scss/grid.scss"></style>
  <script>
  
import Vue from "vue";
import { GridComponent, ColumnDirective, ColumnsDirective, Page, Sort, Toolbar, Edit, Filter, ExcelExport } from "@syncfusion/ej2-vue-grids";
import { ColumnSeries, DataLabel, LineSeries, SplineSeries, SplineAreaSeries, Legend, Tooltip, DateTime, Category, Highlight, ChartAnnotation, StripLine } from "@syncfusion/ej2-vue-charts";
import { L10n, enableRipple  } from '@syncfusion/ej2-base';
import { ToastComponent } from "@syncfusion/ej2-vue-notifications";
import { NumericTextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
import { DatePickerComponent } from "@syncfusion/ej2-vue-calendars";
import zhtwLocalization  from '../language/language.json';
import Loading from 'vue-loading-overlay';
L10n.load(zhtwLocalization);
Vue.use(TooltipPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(DialogPlugin);
Vue.use(Loading);
enableRipple(true);
let Loader      = undefined;
export default {
  components: {
    'ejs-grid': GridComponent,
    'e-column': ColumnDirective,
    'e-columns': ColumnsDirective,
    'ejs-toast': ToastComponent,
    'ejs-datepicker': DatePickerComponent
  },
  provide : {
    grid: [Page, Sort, Toolbar, Edit, Filter, ExcelExport],
        chart: [ColumnSeries, SplineAreaSeries, LineSeries, SplineSeries, Legend, Tooltip, Category,DateTime, DataLabel, Highlight, ChartAnnotation, StripLine],
  },
  name: 'acceptance_scm',
  data: function() {
    return {
      e_receiptno:null,
        datas : [], quityData : null, quityListData : null,
        editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, showAddNewRow: false },
        pageSettings: {pageSize: 50, pageSizes: [10,50,100,200], pageCount: 50 },     
        e_sku_no: null, e_sku_name: null, e_name: null,
        e_quality_id : null, e_check_list_id: null,
        e_input_date: null, e_acceptance_no: null, e_save_location: null, e_view_qty: null, e_quality_qty :null, e_quality_manager : null, e_write_user : null,

        sType21: [ {text: '正常' , value: 0},  {text: '不正常' , value: 1}],
        sType22: [ {text: '完整' , value: 0},  {text: '不完整' , value: 1}],
        sType23: [ {text: '無' , value: 0},  {text: '有' , value: 1}],
        sType24: [ {text: '平整' , value: 0},  {text: '不平整' , value: 1}],
        sType25: [ {text: '左出' , value: 0},  {text: '右出' , value: 1}],
        dropDownFields: { text: 'text', value: 'value' },

        toolbar: [             
          { text: '檢視', tooltipText: '檢視', prefixIcon: 'e-btn-icon e-eye e-icons e-icon-left', id: 'Check' }, 
          { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 'Search'],   
        selectionSettings: { persistSelection: true },
        filterSettings: { type: 'CheckBox' }, 
        visible : false,
        e_selectData : null, e_selectRow: null,
        e_pwd: '', e_pwd2: '', e_header: '', e_fraction_header: '',
        e_quality: 12, e_delivery_date: 1, e_fit: 2, e_service: 3,        
        position: { X: 'Right', Y: "Bottom" },
        min: 0,
        max: 25,
        shwbuttons: true,
        step: 1,
        checked: false,
        isenable: true,
        readonly: false,
        orientation: "Horizontal", 
        ticks: { placement: 'After', largeStep: 25 },
        type: 'MinRange',
        dialogFractionButtons: [ { 
            click: function() { this.hide(); }, 
            buttonModel: { content: '取消', isPrimary: false}
        }],          
       
      };
  },
  methods: {    
    onload:function() {
      // 初始化
    },
    submit:function() {
      this.$emit('onGetMaterialsClose');
    },
    beforeRender: function (args) {
        if (args.target.closest("td")) {
            this.$refs.tooltip.content = args.target.innerText;                
        }
    },
    onQualityChange: function(args) {
      this.e_quality = args.value;
    },
    onDeliveryDateChange: function(args) {
      this.e_delivery_date = args.value;
    },
    onFitChange: function(args) {
      this.e_fit = args.value;
    },
    onServiceChange: function(args) {
      this.e_service = args.value;
    },

    pubDoubleClick: function () {  
       
    },
    editOkClick: function () {           
      this.upData();         
    },
    valueChange: function () {  
      this.isDataChanged = true;
      this.stTime = null;
    },
    load: function() {   

    },       
    addAction: function() {

    },     
    
    onQueryCellInfo(args) {     
      if (args.cell) {
        args.cell.classList.add("tooltip-cell");
        args.cell.setAttribute("title", `${args.column.headerText}: ${args.data[args.column.field]}`);
      }
    }, 
    toolbarClick: function(args) {
      if (args.item.id == "Export") {
        this.$refs.grid.excelExport({ fileName:'品保檢驗.xlsx' });
      }
    
      if (args.item.id == "Check") {      
        if (this.e_selectData == null)
        {
          this.showMsg('請先選擇一筆資料');
          return;
        }
        this.$refs.modalReceiveDialog.show();
      }
    },   

    actionComplete: function() {                             
    },
    rowSelected: function(args) {        
      this.e_selectRow = args.row.getAttribute('aria-rowindex');  
      this.e_selectData = args.data; 
      this.e_receiptno =args.data.receiptno;  
      this.e_sku_no = this.e_selectData.sku_no;
      this.e_sku_name = this.e_selectData.sku_name;
      this.e_name = this.e_selectData.name;
      this.getQuality();
    },    
    getQualityList: function() {    
      this.showLoading();
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/SCMInputCheck/Quality/List?no=${localStorage.getItem('userid')}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        this.hideLoading();
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
        this.datas = response.data.datas;
        console.log(this.datas)
        this.e_selectData = null;
        this.e_selectRow = null;
      })
      .catch((error) => { 
        this.hideLoading();
        this.showError(error) }
      )             
    },       
    getQuality: function() {    
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/SCMInputCheck/Quality?check_list_id=${this.e_selectData.check_list_id}&sku_no=${this.e_sku_no}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
        this.quityData = response.data.datas.header;
        this.quityListData = response.data.datas.body;
        this.e_input_date = response.data.datas.header.input_date;
        this.e_acceptance_no = response.data.datas.header.acceptance_no;
        this.e_save_location = response.data.datas.header.save_location;
        this.e_view_qty = response.data.datas.header.view_qty;
        this.e_quality_qty = response.data.datas.header.quality_qty;
        this.e_quality_manager = response.data.datas.header.quality_manager;
        this.e_write_user = response.data.datas.header.write_user;
        this.e_quality_id = response.data.datas.header.quality_id;
        this.e_check_list_id = response.data.datas.header.check_list_id;

      })
      .catch((error) => { 
        this.showError(error) }
      )             
    },       
    
    showMsg: function (msg) {
      this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
    },
    showError: function (error) {     
      if (error.response.status == 400) {
        for(var key in error.response.data.errors){      
          this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
        }
        return;
      }   
      if (error.response.status == 401) {
        localStorage.removeItem('token'); this.$router.push('/login');
        return;
      }
      this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
    },
    showLoading() {
        Loader = this.$loading.show({
        container: this.$refs.loadingContainer,
        canCancel: true, // default false
        onCancel: this.yourCallbackMethod,
        color: 'red',
        loader: 'dots',  // spinner, dots, bars
        width: 164,
        height: 164,
        backgroundColor: 'black',
        opacity: 0.5,
        zIndex: 999,
        });
    },
    hideLoading() {
        Loader.hide();
    }     
  },

  created() {
    this.getQualityList();
  },

  mounted() {
   
  },
  beforeUpdate() {
    
  },
  beforeDestroy() {
   
  }  
}
</script>
<style scoped>
  .box {
    border-style:solid; 
    border-color: #ced2d8; 
    border-width:1px;
    border-top-width:0px; 
    padding-top: 6px; 
    padding-bottom: 6px;
    border-left-width: 0px;
    display: flex;
    align-items: center;  
  }
  .box-header {
    border-style:solid; 
    border-color: #ced2d8; 
    border-width:1px;
    border-top-width:0px; 
    padding-top: 16px; 
    padding-bottom: 16px;
    border-left-width: 0px;
  }
</style>
<style lang="scss" src="../../scss/base.scss"></style>